import FsnNetworkIcon from '@/assets/FsnNetworkIcon'
import { DetailCard } from '@/components/patterns/detail-page'
import { Typography } from '@/components/ui/typography'
import { formatCurrency } from '@/lib/utils'
import type { OrderSourceLink } from '@/lib/services/sales-orders/sales-orders.types'
import { FsnWireInSourceLink } from './FsnWireInSourceLink'

type FsnWireInFinancialNoticeProps = {
  cancelled?: boolean
  refusedChange?: OrderSourceLink['fsn_refused_change']
  ended?: boolean
  expectedPayout?: number
  incomingOrderId?: number | string | null
}

export function FsnWireInFinancialNotice({
  cancelled = false,
  refusedChange = null,
  ended = false,
  expectedPayout = 0,
  incomingOrderId = null,
}: FsnWireInFinancialNoticeProps) {
  // Once FSN ends the order (cancel, reroute, or the shop's refusal) no payout is owed, even if
  // delivery blocked the local cancellation.
  const noPayout = cancelled || ended || Boolean(refusedChange)
  return (
    <DetailCard accent="periwinkle" className="lg:col-span-2" contentClassName="space-y-3 p-5">
      <div className="flex items-start gap-3">
        <FsnNetworkIcon className="mt-0.5 size-5" aria-hidden="true" />
        <div className="min-w-0 space-y-1.5">
          <Typography variant="eyebrow">
            {noPayout ? 'Network payout' : 'Expected network payout'}
          </Typography>
          <Typography variant="h4" className="pb-0 tabular-nums">
            {noPayout
              ? 'No network payout expected'
              : expectedPayout > 0
                ? formatCurrency(expectedPayout)
                : 'Flower Shop Network'}
          </Typography>
          <Typography variant="supporting" wrap="pretty" className="block">
            {refusedChange
              ? `Your shop refused this order after Flower Shop Network requested changes.${refusedChange.reason ? ` Reason: ${refusedChange.reason}` : ''}${cancelled ? '' : ' Delivery was already recorded here, so contact Flower Shop Network to resolve it.'}`
              : cancelled
                ? 'This order was cancelled in Flower Shop Network. Contact Flower Shop Network directly if you have questions about the cancellation or believe a payout is still due.'
                : ended
                  ? 'Flower Shop Network ended this order after delivery was recorded here. Contact Flower Shop Network to resolve it.'
                  : 'The customer payment and payout stay in Flower Shop Network. Payments, refunds, customer emails, and cancellations are handled outside this order.'}
          </Typography>
          <FsnWireInSourceLink incomingOrderId={incomingOrderId} />
        </div>
      </div>
    </DetailCard>
  )
}
